import { createTheme } from '@mui/material';
var augmentColor = createTheme().palette.augmentColor;
export var palette = {
    primary: augmentColor({
        color: {
            main: '#3364D9',
        },
    }),
    secondary: augmentColor({
        color: {
            main: '#95B4FF',
        },
    }),
    error: augmentColor({
        color: {
            main: '#ff5252',
        },
    }),
    warning: augmentColor({
        color: {
            main: '#ffea00',
        },
    }),
    info: augmentColor({
        color: {
            main: '#62cae6',
        },
    }),
    success: augmentColor({
        color: {
            main: '#66bb6a',
        },
    }),
    text: {
        primary: '#1E1D1B',
    },
    common: {
        black: '#122b3b',
        white: '#fff',
        purple: '#A154BA',
        salmon: '#FB9C84',
        'faux-white': '#F4F4F4',
        'faux-black': '#122B3B',
    },
    custom: {
        normalCategory: augmentColor({
            color: { main: '#98bc24' },
        }),
        mildCategory: augmentColor({
            color: { main: '#e57508' },
        }),
        moderateCategory: augmentColor({
            color: { main: '#c32d0e' },
        }),
    },
};
